import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import Utils from '../../utils';
import {
	StyledStaleOfflineCleanupContent,
	StaleOfflineCleanupLabel,
	StaleOfflineCleanupClose,
	CleanUpStaleOfflineButton,
	KeepStaleOfflineButton,
} from './styles';

interface StaleOfflineCleanupContentProps {
	close: () => void;
	cleanUp: () => void;
	staleCount: number;
	isCleaningUp: boolean;
}

const StaleOfflineCleanupContent = (props: StaleOfflineCleanupContentProps) => {
	const { close, cleanUp, staleCount, isCleaningUp } = props;

	return (
		<StyledStaleOfflineCleanupContent>
			<StaleOfflineCleanupClose onClick={close}>
				{Utils.getSvgIcon('iconset_close-1')}
			</StaleOfflineCleanupClose>
			<StaleOfflineCleanupLabel>
				<Translate
					value={staleCount === 1
						? 'messages.stale_offline_item_prompt'
						: 'messages.stale_offline_items_prompt'}
					count={String(staleCount)}
				/>
			</StaleOfflineCleanupLabel>
			<CleanUpStaleOfflineButton onClick={cleanUp} disabled={isCleaningUp}>
				<Translate value="messages.clean_up_stale_offline" />
			</CleanUpStaleOfflineButton>
			<KeepStaleOfflineButton onClick={close} disabled={isCleaningUp}>
				<Translate value="messages.keep_stale_offline_for_now" />
			</KeepStaleOfflineButton>
		</StyledStaleOfflineCleanupContent>
	);
};

export default StaleOfflineCleanupContent;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/StaleOfflineCleanupContent/index.tsx